import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { SortOrder } from '@/components/ui/table'
import {
  LeaseStatus,
  UnitListItem,
  UnitOccupancyCounts,
  UnitOccupancyStatus,
} from '@/models/features'

import { authAPI } from '../new-api'

export interface GetUnitsRequest {
  buildingId?: number
  unitStatus?: 'all' | Lowercase<UnitOccupancyStatus>
  search?: string
  dateFrom?: number
  dateTo?: number
  leaseStatus?: LeaseStatus[]
  sortBy?: string
  sortOrder?: SortOrder
  skip?: number
  limit?: number
}

export interface GetUnitsResponse {
  units: UnitListItem[]
  total: number
  occupancyCounts: UnitOccupancyCounts
  skip: number
  limit: number
}

export const GET_UNITS_BASE_QUERY_KEY = 'useGetUnits'

export const getUnitsQueryKey = (data: GetUnitsRequest) => [GET_UNITS_BASE_QUERY_KEY, data] as const

export const getUnits = async (data: GetUnitsRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<GetUnitsResponse>('/units', {
    params: data,
    signal,
  })
  return response.data
}

export const useGetUnits = (data: GetUnitsRequest) => {
  return useQuery<GetUnitsResponse, Error, GetUnitsResponse, ReturnType<typeof getUnitsQueryKey>>({
    enabled: !!data.buildingId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getUnits(data, signal),
    queryKey: getUnitsQueryKey(data),
  })
}
